"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinner = void 0;
var React = require("react");
var Text_1 = require("player-common-controls/controls/Text/Text");
var Panel_1 = require("player-layout-controls/controls/Panel");
var player_preloader_1 = require("player-preloader");
require("./LoadingSpinner.css");
var LoadingSpinner = (function (_super) {
    __extends(LoadingSpinner, _super);
    function LoadingSpinner(props) {
        return _super.call(this, props) || this;
    }
    LoadingSpinner.prototype.renderLoadingSpinner = function () {
        return this.props.isLoading && React.createElement(Panel_1.Panel, { paddingAll: "Medium" },
            React.createElement(player_preloader_1.default, { isVisible: this.props.isVisible }));
    };
    LoadingSpinner.prototype.renderStatusText = function () {
        return this.props.displayStatus && React.createElement(Panel_1.Panel, null,
            React.createElement(Text_1.Text, { text: this.props.statusText }));
    };
    LoadingSpinner.prototype.render = function () {
        if (!this.props.isVisible)
            return null;
        return (React.createElement("div", { className: "p-loading", "data-tag": this.props.tag },
            React.createElement("div", { className: "background" }),
            React.createElement("div", { className: "content" },
                this.renderLoadingSpinner(),
                this.props.displayStatus ?
                    React.createElement("div", { className: "text" }, this.renderStatusText())
                    :
                        React.createElement("div", null, this.renderStatusText()))));
    };
    LoadingSpinner.defaultProps = {
        tag: null,
        isVisible: false,
        isLoading: false,
        displayStatus: false,
        statusText: ''
    };
    return LoadingSpinner;
}(React.Component));
exports.LoadingSpinner = LoadingSpinner;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['application-workflow'])
        csod.engine.controls['application-workflow'] = {};
    csod.engine.controls['application-workflow']['LoadingSpinner'] = LoadingSpinner;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["LoadingSpinner"] = [];


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/2c51a2fe812ded8e/src/.tmp/LoadingSpinner/LoadingSpinner.js
// module id = 556
// module chunks = 0